import React from 'react';
const SvgDwg = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#C8D8EA" d="M3 1v30h26V9h-8V1H3z" />
      <path fill="#2F649F" d="M4 2v28h24V9h-7V2H4z" />
      <path fill="#FDC137" d="M3 16v15h26v-4.7L12 16H3z" />
      <g opacity={0.8} fill="#FFF">
        <path d="M13 6v5H8V6h3m3-1H7v7h7V5zM4 8h3v1H4z" />
        <path d="M10 8h1v1h-1zM10 11h1v5h-1zM10 2h1v3h-1zM13 8h16v1H13z" />
      </g>
      <path opacity={0.2} fill="#1B3F63" d="M29 17l-8-8h8v8z" />
      <path fill="#9BB9D9" d="M21 1l8 8h-8V1z" />
      <g opacity={0.8}>
        <path d="M5 29h2c.4 0 2 0 2-2.5S7.4 24 7 24H5v5zm2-4c.3 0 1 0 1 1.5S7.2 28 7 28H6v-3h1zM16 26.5c0 1.4 1.1 2.5 2.5 2.5s2.5-1.2 2.5-2v-1h-2v1h1c0 .4-.8 1-1.5 1-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5c.4 0 .8.2 1.1.4l.7-.7c-.5-.5-1.1-.7-1.8-.7-1.4 0-2.5 1.1-2.5 2.5zM11.5 29l1-3 1 3h1.2l1.3-5h-1l-1 3.5-1-3.5h-1l-1 3.4-1-3.4H9l1.3 5h1.2z" />
      </g>
    </svg>
  );
});
export default SvgDwg;
SvgDwg.iconName = 'dwg';
SvgDwg.displayName = 'SvgDwg';
